import React, { useContext, useEffect, useState } from 'react'
import { Button, FormControl, List, ListItem, ListItemText, TextField } from '@mui/material';
import { BRAND_LOGO_URL, X_TENANT_ID } from '../../common/ActionUrl';
import { AuthContext } from '../../common/Auth';
import Loader from '../../common/Loader';
import { _useToasts } from '../../common/_useToasts'
import useForm from '../banner/customHooks';
import axios from 'axios';
import { USERTYPES } from '../../constant/userType';
import DeleteIcon from '@mui/icons-material/Delete';
import { Validate } from './Validate';


const BrandLogoImgForm = ({ brandLogoId, handleClose }) => {
    const { _addToast } = _useToasts();

    const { user, userType, getClientLogo } = useContext(AuthContext)
    const userId = user?.userId
    const [isLoading, setIsLoading] = useState(false)

    const { inputs, setImage, handleFileInputChange, handleInputChange, handleSubmit, resetForm, errors } = useForm({ 
        image: "", 
        widthSize: "", 
        link: "",
        createdBy: "", 
        updatedBy: "" }, Validate, createActionGridCallback);

    const [brandLogoData, setbrandLogoData] = useState({});
    const [tempImage, setTempImage] = useState("");
    const [tempTitleImage, setTempTitleImage] = useState("");

    const getActionGridById = () => {
        setIsLoading(true)
        const requestOptions = {
            headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
        };
        axios.get(BRAND_LOGO_URL + brandLogoId, requestOptions)
            .then(res => {
                setIsLoading(false)
                if (res.data.error) {
                    _addToast(res.data.message, {
                        appearance: "error",
                        autoDismiss: true
                    });
                } else {
                    setbrandLogoData(res.data)
                }
            })
            .catch(err => {
                console.log('err', err);
            });
    }

    useEffect(() => {
        if (brandLogoId) {
            getActionGridById()
        }
    }, [brandLogoId])

    async function createActionGridCallback() {
        setIsLoading(true)
        const requestOptions = {
            headers: { 'Content-Type': 'multipart/form-data', 'X-TENANT-ID': X_TENANT_ID },
        };

        const formData = new FormData();

        formData.append("image", inputs.image);
        formData.append("widthSize", inputs.widthSize);
        formData.append("link", inputs.link);
        formData.append("createdBy", userId);
        formData.append("updatedBy", userId);

        if (brandLogoId) {
            axios.patch(BRAND_LOGO_URL + brandLogoId, formData, requestOptions)
                .then(res => {
                    setIsLoading(false)
                    if (res.data.error) {
                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        handleClose()
                        getClientLogo()
                        _addToast("Brand logo updated successfully", {
                            appearance: "success",
                            autoDismiss: true
                        });
                    }
                }).catch((error, config, code, request, response) => {
                    if (error.response && error.response.data.statusCode === 409) {
                        _addToast(error.response.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        });
                    } else {
                        _addToast('Issues while update brand logo', {
                            appearance: "error",
                            autoDismiss: true
                        });
                    }
                });
        }
    }

    useEffect(() => {
        if (inputs.image != '' && inputs.image !== "undefined" && inputs.image !== undefined && inputs.image.name) {
            setTempImage(URL.createObjectURL(inputs.image))
        }

    }, [inputs.image])


    const [value, setValue] = useState(0);

    useEffect(() => {
        if (Object.keys(brandLogoData).length > 0) {
            setTempImage(brandLogoData.image)
            setTempTitleImage(brandLogoData.titleImage)
            inputs.image = brandLogoData.image
            inputs.widthSize = brandLogoData.widthSize
            inputs.link = brandLogoData.link

            inputs.createdBy = brandLogoData.createdBy
            inputs.updatedBy = brandLogoData.updatedBy
            setValue(value => value + 1);
        }
    }, [brandLogoData])

    return (
        <>
            {isLoading && (
                <Loader />
            )}
            {userType !== USERTYPES.USER ?
                <div className="banner-form" style={{ 'minHeight': '50vh' }}>
                    <form className="banner-form-style" onSubmit={handleSubmit}>
                        <List>
                            <ListItem>
                                <div className="row w-100">
                                    <div className="col-lg-3">
                                        <ListItemText id="switch-list-label-wifi" primary="Image" />
                                    </div>
                                    <div className="col-lg-9">
                                        <FormControl variant="outlined" className="w-100">
                                            <div className="uploadedImg">
                                                <input onChange={handleFileInputChange}
                                                    type="file"
                                                    name="image"
                                                />
                                                {!errors.image && tempImage != "" && tempImage != 'undefined' && (
                                                    <>
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}>
                                                            <img height="50px" width="50px" src={tempImage} className="mt-15 mb-20"></img>

                                                            <DeleteIcon
                                                                className="text-error"
                                                                title={"Delete"}
                                                                onClick={() => {
                                                                    setImage("", 'image')
                                                                    setTempImage("")
                                                                }}
                                                                aria-label=""
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {errors && errors.image && <span className="color-red">{errors.image}</span>}
                                            </div>
                                        </FormControl>
                                    </div>
                                </div>
                            </ListItem>

                            <ListItem>
                                <div className="row w-100">
                                    <div className="col-lg-3">
                                        <ListItemText
                                            id="switch-list-label-wifi"
                                            primary="Logo Width"
                                        />
                                    </div>
                                    <div className="col-lg-9">
                                        <TextField
                                            id="outlined-basic"
                                            label=""
                                            type="number"
                                            size="medium"
                                            variant="outlined"
                                            fullWidth
                                            className="w-100"
                                            value={inputs.widthSize}
                                            onChange={handleInputChange}
                                            name="widthSize"
                                        />
                                    </div>
                                </div>
                            </ListItem>
                            <ListItem>
                                <div className="row w-100">
                                    <div className="col-lg-3">
                                        <ListItemText id="switch-list-label-wifi" primary="Link" />
                                    </div>
                                    <div className="col-lg-9">
                                        <TextField
                                            id="outlined-basic"
                                            label=""
                                            size="medium"
                                            variant="outlined"
                                            fullWidth
                                            className="w-100"
                                            value={inputs.link}
                                            onChange={handleInputChange}
                                            name="link"
                                        />
                                    </div>
                                </div>
                            </ListItem>
                            <ListItem>
                                <button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
                                <Button variant="contained" color="primary" className="bannerbutton" type="submit"> {brandLogoId ? "Update" : "Save"}</Button>
                            </ListItem>
                        </List>

                    </form>
                </div>

                : <h2>You haven't authority for update settings</h2>
            }
        </>
    )
}

export default BrandLogoImgForm